document.addEventListener('DOMContentLoaded', () => {
  const atcBtn = document.querySelector('.f-main-product-form button.f-product-form__submit')
  if (!atcBtn) return;
  
  const btn = atcBtn.querySelector('span')
  let originalText = btn.textContent

  // Update originalText when variant changes (button gets updated with new price)
  document.addEventListener('variant:changed', (event) => {
    // More robust approach with retry logic
    const updateButtonWithRetry = (attempts = 0) => {
      const newBtn = document.querySelector('.f-main-product-form button.f-product-form__submit span')
      if (newBtn && event.detail.variant) {
        // Construct the originalText with price from variant data
        const variant = event.detail.variant
        const price = formatMoney(variant.price, window.FoxThemeSettings.money_format)
        
        originalText = `Add to bag - ${price}`
        updateCTA(newBtn, originalText)
      } else if (attempts < 5) {
        // Retry up to 5 times with increasing delays
        setTimeout(() => updateButtonWithRetry(attempts + 1), 50 * (attempts + 1))
      }
    }
    
    // Start with immediate check, then retry if needed
    updateButtonWithRetry()
  })

  document.addEventListener('optin-changed', (e) => {
    const optedIn = e.detail.optedIn
    const currentBtn = document.querySelector('.f-main-product-form button.f-product-form__submit span')
    if (currentBtn) {
      if (optedIn) {
        currentBtn.textContent = 'SUBSCRIBE NOW'
      } else {
        currentBtn.textContent = originalText
      }
    }
  })

  document.addEventListener('change', () =>{
    const currentBtn = document.querySelector('.f-main-product-form button.f-product-form__submit span')
    if (currentBtn) {
      updateCTA(currentBtn, originalText)
    }
  })
  updateCTA(btn, originalText)
})

function updateCTA(btn, originalText) {
  const state = window.OG.store.getState()
  if (state && btn) {
    const optedInArray = state.optedin
    const variantId = document.querySelector('.f-main-product-form input[name="id"]').value
    
    // Get current variant price from ProductData
    const getCurrentVariantPrice = () => {
      try {
        const productDataScript = document.getElementById('ProductData')
        if (productDataScript) {
          const productData = JSON.parse(productDataScript.textContent)
          const currentVariant = productData.variants.find(v => v.id.toString() === variantId)
          if (currentVariant) {
            return formatMoney(currentVariant.price, window.FoxThemeSettings.money_format)
          }
        }
      } catch (e) {
        console.warn('Could not get variant price:', e)
      }
      return null
    }
    
    if (variantId && optedInArray.length) {
      const match = optedInArray.find(obj => obj.id === variantId)

      if (match) {
        btn.textContent = 'SUBSCRIBE NOW'
      } else {
        // Get current variant price instead of using potentially stale originalText
        const currentPrice = getCurrentVariantPrice()
        if (currentPrice) {
          btn.textContent = `Add to bag - ${currentPrice}`
        } else {
          btn.textContent = originalText
        }
      }
    } else {
      // No subscription state, use originalText or get current price
      const currentPrice = getCurrentVariantPrice()
      if (currentPrice) {
        btn.textContent = `Add to bag - ${currentPrice}`
      } else {
        btn.textContent = originalText
      }
    }
  }
}
